// extracted by mini-css-extract-plugin
export default {"container":"Table-container___xIiHi","header":"Table-header___OEu9m","title":"Table-title___cUDDB","no-name":"Table-no-name___YfJf0"};